import * as React from 'react';
import { makeStyles, FormControl, FormLabel, FormGroup, withStyles, TextField } from '@material-ui/core';
import { neutral } from '../../../theme/colors';

interface Props {
  title: string;
  min: number | '';
  max: number | '';
  setMin: (min: number | '') => void;
  setMax: (min: number | '') => void;
  isValid: boolean;
  setIsValid: (isValid: boolean) => void;
}

const useStyles = makeStyles({
  formGroup: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    whiteSpace: 'nowrap'
  },
  formLabel: {
    color: neutral[600],
    fontWeight: 500
  },
  input: {
    maxWidth: 100,
    marginTop: 8,
    marginBottom: 8
  },
  dash: {
    margin: '4px',
    fontSize: '22px',
    fontWeight: 500
  }
});

const CustomizedTextField = withStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      fontSize: '14px'
    }
  }
})(TextField);

/**
 * Render a section of filter options in the fitler sidebar
 */
const MinMaxFilterGroup = ({ title, min, max, setMin, setMax, isValid, setIsValid }: Props) => {
  const classes = useStyles();

  const validRegex = /(^\d+$|^$)/;

  const handleMinChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const next = event.target.value;
    if (next.match(validRegex)) {
      setMin(next === '' ? '' : Number(next));
    }
  };

  const handleMaxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const next = event.target.value;
    if (next.match(validRegex)) {
      setMax(next === '' ? '' : Number(next));
    }
  };

  React.useEffect(() => {
    if (max !== '' && min !== '' && Number(max) <= Number(min)) {
      setIsValid(false);
    } else {
      setIsValid(true);
    }
  }, [min, max]);

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend" className={classes.formLabel}>
        {title}
      </FormLabel>
      <FormGroup className={classes.formGroup}>
        <CustomizedTextField
          size="small"
          variant="outlined"
          label="Min"
          value={min}
          onChange={handleMinChange}
          error={!isValid}
          className={classes.input}
        />
        <span className={classes.dash}>-</span>
        <CustomizedTextField
          size="small"
          variant="outlined"
          label="Max"
          value={max}
          onChange={handleMaxChange}
          error={!isValid}
          className={classes.input}
        />
      </FormGroup>
    </FormControl>
  );
};

export default MinMaxFilterGroup;
